"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.goToWebinars = goToWebinars;

var RequestState = _interopRequireWildcard(require("lead-flows-ui/utils/RequestState"));

var Actions = _interopRequireWildcard(require("lead-flows-ui/actions/GoToWebinars"));

var INIT_STATE = {
  webinars: [],
  webinarsSyncEnabled: false,
  requestState: RequestState.NOT_REQUESTED,
  requestStateSettings: RequestState.NOT_REQUESTED
};

function goToWebinars() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Actions.REQUEST_WEBINARS:
      return Object.assign({}, state, {
        requestState: RequestState.REQUEST_SUBMITTED
      });

    case Actions.SUCCEED_GETTING_WEBINARS:
      return Object.assign({}, state, {
        requestState: RequestState.SUCCESS
      });

    case Actions.RECEIVE_WEBINARS:
      return Object.assign({}, state, {
        webinars: action.webinars
      });

    case Actions.FAIL_GETTING_WEBINARS:
      return Object.assign({}, state, {
        requestState: RequestState.ERROR
      });

    case Actions.REQUEST_WEBINAR_SETTINGS:
      return Object.assign({}, state, {
        requestStateSettings: RequestState.REQUEST_SUBMITTED
      });

    case Actions.SUCCEED_GETTING_WEBINAR_SETTINGS:
      return Object.assign({}, state, {
        requestStateSettings: RequestState.SUCCESS
      });

    case Actions.RECEIVE_WEBINAR_SETTINGS:
      return Object.assign({}, state, {
        webinarsSyncEnabled: action.settings.enabled
      });

    case Actions.FAIL_GETTING_WEBINAR_SETTINGS:
      return Object.assign({}, state, {
        requestStateSettings: RequestState.ERROR
      });

    default:
      return state;
  }
}